/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
	{
		id: 'divider1',
		type: 'divider',
	},
	{
		id: 'auranow',
		title: 'Aura now',
		type: 'basic',
		icon: 'heroicons_outline:sparkles',
		link: '/apps/aura-now',
		auth: ['/menu-now'],
		disabled: true,
	},
	// Shared Access - External Users Menu
	{
		id: 'shared-access-drillholes',
		title: 'Shared Drillholes',
		type: 'basic',
		icon: 'heroicons_outline:clipboard-list',
		link: '/external/hole',
		auth: ['/shared-access'],
	},
	{
		id: 'tasks',
		title: 'Tasks',
		type: 'basic',
		icon: 'heroicons_outline:check-circle',
		link: '/apps/tasks',
		auth: ['/gpp/tasks'],
		disabled: false,
	},
	{
		id: 'sites',
		title: 'Sites',
		type: 'basic',
		icon: 'heroicons_outline:location-marker',
		auth: ['/exploration-users'],
		link: '/apps/sites',
	},
	{
		id: 'dashboards',
		title: 'Dashboards',
		subtitle: 'Summary of essential insights and data',
		auth: ['/exploration-users'],
		type: 'group',
		children: [
			{
				id: 'dashboards.project',
				title: 'Projects',
				type: 'basic',
				icon: 'heroicons_outline:globe',
				link: '/dashboards/project',
				disabled: false,
				auth: ['/global/management'],
			},
			{
				// Painel de gestão dos processos (Camunda): quem está com cada
				// atividade, há quanto tempo, e performance do time por
				// furo/target/atividade. Grupo próprio para liberar só a gestão.
				id: 'dashboards.process-management',
				title: 'Process management',
				type: 'basic',
				icon: 'heroicons_outline:presentation-chart-line',
				link: '/apps/process-monitor',
				disabled: false,
				auth: ['/roles/process_management'],
			},
			{
				id: 'dashboards.finance',
				title: 'Finance',
				type: 'basic',
				icon: 'heroicons_outline:cash',
				link: '/dashboards/analytics',
				disabled: false,
				auth: ['/global/management'],
			},
		],
	},
	{
		id: 'apps',
		title: 'Applications',
		subtitle: 'Aura Minerals management applications',
		auth: ['/exploration-users'],
		type: 'group',
		children: [
			{
				id: 'apps.drilling',
				title: 'Drilling',
				//subtitle: 'Drilling operations and data management',
				type: 'collapsable',
				icon: 'heroicons_outline:inbox-in',
				children: [
					{
						id: 'apps.drilling.drillholes',
						title: 'Drillholes',
						type: 'basic',
						icon: 'heroicons_outline:clipboard-check',
						link: '/apps/drillholes',
					},
					{
						id: 'apps.drilling.monthly-report',
						title: 'Monthly report',
						type: 'basic',
						icon: 'heroicons_outline:document-report',
						link: '/apps/drilling-report',
					},
				],
			},
			{
				id: 'apps.laboratory',
				title: 'Laboratory',
				//subtitle: 'Laboratory management and results',
				type: 'collapsable',
				icon: 'heroicons_outline:beaker',
				children: [
					{
						id: 'apps.laboratory.despatch',
						title: 'Despatch',
						type: 'basic',
						icon: 'heroicons_outline:truck',
						link: '/apps/laboratory/despatches',
						// Aberto a todos hoje. Para restringir ao grupo, depois que ele
						// existir no Keycloak, basta descomentar:
						// auth: ['/roles/laboratory/despatches'],
						disabled: false,
					},
					{
						id: 'apps.laboratory.samples',
						title: 'Samples',
						type: 'basic',
						link: '/apps/laboratory/samples',
						icon: 'heroicons_outline:beaker',
						// Aberto a todos hoje. Para restringir ao grupo, depois que ele
						// existir no Keycloak, basta descomentar:
						// auth: ['/roles/laboratory/samples'],
						disabled: false,
					},
					{
						id: 'apps.laboratory.certificates',
						title: 'Laboratory jobs',
						type: 'basic',
						link: '/apps/laboratory/laboratory-jobs',
						icon: 'heroicons_outline:document-text',
						auth: ['/global/management', '/roles/laboratory/laboratory-jobs'],
						disabled: false,
					},
					{
						id: 'apps.laboratory.qaqc',
						title: 'QAQC',
						type: 'collapsable',
						icon: 'heroicons_outline:badge-check',
						// O curinga deixa o menu aparecer para quem tem QUALQUER um dos
						// grupos por item abaixo; cada filho decide o que mostrar.
						auth: ['/roles/qaqc_analyst', '/roles/laboratory/qaqc/*'],
						children: [
							{
								id: 'apps.laboratory.qaqc.analytics',
								title: 'Analytics',
								type: 'basic',
								link: '/apps/qaqc/analytics-dashboard',
								icon: 'heroicons_outline:beaker',
								auth: ['/roles/qaqc_analyst', '/roles/laboratory/qaqc/analytics'],
							},
							{
								id: 'apps.laboratory.qaqc.reports-management',
								title: 'Reports Management',
								type: 'basic',
								link: '/apps/qaqc/reports-management',
								icon: 'heroicons_outline:clipboard-check',
								auth: ['/roles/qaqc_analyst', '/roles/laboratory/qaqc/reports-management'],
							},
							{
								id: 'apps.laboratory.qaqc.reanalysis-tracking',
								title: 'Reanalysis Tracking',
								type: 'basic',
								link: '/apps/qaqc/reanalysis-tracking',
								icon: 'heroicons_outline:refresh',
								auth: ['/roles/qaqc_analyst', '/roles/laboratory/qaqc/reanalysis-tracking'],
							},
							{
								id: 'apps.laboratory.qaqc.stock-control',
								title: 'Stock Control',
								type: 'basic',
								link: '/apps/qaqc/stock-control',
								icon: 'heroicons_outline:archive',
								auth: ['/roles/qaqc_analyst', '/roles/laboratory/qaqc/stock-control'],
							},
						],
					},
					{
						id: 'apps.laboratory.sample-labeling',
						title: 'Sample labeling',
						type: 'collapsable',
						icon: 'heroicons_outline:collection',
						hidden: () => true,
						children: [
							{
								id: 'apps.laboratory.sample-labeling.generate',
								title: 'Generate',
								type: 'basic',
								link: '/apps/sample-labeling/new-label-print',
								icon: 'heroicons_outline:tag',
							},
							{
								id: 'apps.laboratory.sample-labeling.sample-labeling.print',
								title: 'Search and print',
								type: 'basic',
								link: '/apps/sample-labeling',
								icon: 'heroicons_outline:printer',
							},
						],
					},
				],
			},
			{
				id: 'apps.titles',
				title: 'Mineral title',
				//subtitle: 'Drilling operations and data management',
				type: 'collapsable',
				icon: 'heroicons_outline:briefcase',
				children: [
					{
						id: 'apps.titles.monitor',
						title: ' Tittle Monitor',
						type: 'basic',
						icon: 'heroicons_outline:briefcase',
						link: '/apps/mineral-title',
						disabled: true,
					},
				],
			},
			{
				id: 'management-hub',
				title: 'Management Hub',
				type: 'basic',
				//icon for control center
				icon: 'heroicons_outline:cog',
				link: '/apps/management-hub',
				auth: ['/roles/app_management', '/roles/managementhub/*'],
			},
			{
				// Uso do sistema: quem usa, quando e em que área. Só o grupo /roles/system_admin.
				id: 'system-usage',
				title: 'System usage',
				type: 'basic',
				icon: 'heroicons_outline:chart-pie',
				link: '/apps/system-usage',
				auth: ['/roles/system_admin'],
			},
			{
				id: 'about',
				title: 'About',
				type: 'basic',
				icon: 'heroicons_outline:information-circle',
				link: '/apps/about',
				auth: ['/roles/about'],
			},
			{
				id: 'atualizacoes',
				title: 'Atualizações',
				type: 'basic',
				icon: 'heroicons_outline:sparkles',
				link: '/apps/atualizacoes',
			},
		],
	},
];

export const compactNavigation: FuseNavigationItem[] = [
	{
		id: 'dashboards',
		title: 'Dashboards',
		tooltip: 'Dashboards',
		type: 'aside',
		icon: 'heroicons_outline:home',
		children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'apps',
		title: 'Apps',
		tooltip: 'Apps',
		type: 'aside',
		icon: 'heroicons_outline:qrcode',
		children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'pages',
		title: 'Pages',
		tooltip: 'Pages',
		type: 'aside',
		icon: 'heroicons_outline:document-duplicate',
		children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'user-interface',
		title: 'UI',
		tooltip: 'UI',
		type: 'aside',
		icon: 'heroicons_outline:collection',
		children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'navigation-features',
		title: 'Navigation',
		tooltip: 'Navigation',
		type: 'aside',
		icon: 'heroicons_outline:menu',
		children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
];
export const futuristicNavigation: FuseNavigationItem[] = [
	{
		id: 'dashboards',
		title: 'DASHBOARDS',
		type: 'group',
		children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'apps',
		title: 'APPS',
		type: 'group',
		children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'others',
		title: 'OTHERS',
		type: 'group',
	},
	{
		id: 'pages',
		title: 'Pages',
		type: 'aside',
		icon: 'heroicons_outline:document-duplicate',
		children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'user-interface',
		title: 'User Interface',
		type: 'aside',
		icon: 'heroicons_outline:collection',
		children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'navigation-features',
		title: 'Navigation Features',
		type: 'aside',
		icon: 'heroicons_outline:menu',
		children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
];
export const horizontalNavigation: FuseNavigationItem[] = [
	{
		id: 'dashboards',
		title: 'Dashboards',
		type: 'group',
		icon: 'heroicons_outline:home',
		children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'apps',
		title: 'Apps',
		type: 'group',
		icon: 'heroicons_outline:qrcode',
		children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'pages',
		title: 'Pages',
		type: 'group',
		icon: 'heroicons_outline:document-duplicate',
		children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'user-interface',
		title: 'UI',
		type: 'group',
		icon: 'heroicons_outline:collection',
		children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
	{
		id: 'navigation-features',
		title: 'Misc',
		type: 'group',
		icon: 'heroicons_outline:menu',
		children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
	},
];
